import { nodeApi } from '$lib/settings'
import { createQuery } from '@tanstack/svelte-query'

export const sourcePublicIdDefinitionQueryKey = ['settings-source-public-id-definition']

async function getSourcePublicIdDefinitionSettings() {
	const response =
		await nodeApi.settingsV1TenantSettingsService.tenantSettingsServiceGetSourcePublicIdDefinition()
	return response.data.definition
}

export function useSourcePublicIdDefinitionQuery() {
	return createQuery({
		queryKey: sourcePublicIdDefinitionQueryKey,
		queryFn: getSourcePublicIdDefinitionSettings,
	})
}
